import React, { useState } from "react";
import {
  Button,
  makeStyles,
  Radio,
  RadioGroup,
  Text,
  typographyStyles,
} from "@fluentui/react-components";
import { Dismiss20Regular, Info20Regular, Settings20Regular } from "@fluentui/react-icons";
import classNames from "classnames";
import { ReviewMode } from "src/types";
import "./OutlineHeading.css";

import type { RadioGroupOnChangeData } from "@fluentui/react-components";

const useStyles = makeStyles({
  heading: typographyStyles.subtitle1,
  controlsTitle: typographyStyles.body1Strong,
});

export interface OutlineHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
  onChangeReviewMode: (mode: ReviewMode) => void;
}

export function OutlineHeading({
  className,
  onChangeReviewMode,
  ...props
}: React.PropsWithChildren<OutlineHeadingProps>) {
  const [expanded, setExpanded] = useState(false);
  const [reviewMode, setReviewMode] = useState<ReviewMode>(ReviewMode.AllParagraphs);
  const styles = useStyles();

  const handleChange = (_: React.FormEvent<HTMLElement>, data: RadioGroupOnChangeData) => {
    setReviewMode(data.value as ReviewMode);
    onChangeReviewMode(data.value as ReviewMode);
  };

  return (
    <div {...props} className={classNames("outline-heading-container", className)}>
      <div className="outline-heading">
        <Text className={styles.heading}>Document Summary</Text>
        <Button
          appearance="transparent"
          icon={expanded ? <Dismiss20Regular /> : <Settings20Regular />}
          onClick={() => setExpanded((prev) => !prev)}
        />
      </div>
      <div className={classNames("outline-heading-controls", { expanded })}>
        <div className="outline-heading-controls-title">
          <Text className={styles.controlsTitle}>Suggested Styling Review</Text>
          <Info20Regular />
        </div>
        <RadioGroup value={reviewMode} onChange={handleChange}>
          <Radio
            value={ReviewMode.AllParagraphs}
            label="Review all styles, including manually applied"
          />
          <Radio value={ReviewMode.ChangesOnly} label="Review only suggested styles" />
        </RadioGroup>
      </div>
    </div>
  );
}
